/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")


  
    
export interface API20971Item {
  
  /** 云分类id */
  cloudCategoryId?: string;
  
  /** 云分类名称 */
  cloudCategoryName?: string;
  
  /**  */
  moduleList?: API20971Item[];
  
};
    
  



  export type API20971Req = {};



export interface API20971Res {
  /**   */
  list?: API20971Item[];
  
};


// 20971 获取云模块的列表

export interface IUseGetAPI20971Return {
  /** 获取云模块的列表: 接口请求状态 */
  isAPI20971Loading: boolean;
  /** 获取云模块的列表: 接口请求返回数据 */
  dataAPI20971: API20971Res;
  /**  获取云模块的列表: 接口数据请求方法 */
  fetchAPI20971Data:  ( config?: YWRequestConfig) => Promise<API20971Res>;
  /** 获取云模块的列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI20971 = ():IUseGetAPI20971Return => {
  let isMount = true;
  const [isAPI20971Loading, setIsAPI20971Loading] = useState(false);
  const [dataAPI20971, setDataAPI20971] = useState<API20971Res>({} as API20971Res);
  const requestUrl = `${basePath}/ywwl-admin/desktop/cloud/list/tree`;

  const fetchAPI20971Data = async ( config?: YWRequestConfig): Promise<API20971Res> => {
  
    if ( isMount ) {
      setIsAPI20971Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API20971Res>(`${basePath}/ywwl-admin/desktop/cloud/list/tree`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI20971(res || {} as API20971Res);
        setIsAPI20971Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI20971Loading(false);
      }
      return false as unknown as API20971Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI20971Loading,
    dataAPI20971,
    fetchAPI20971Data,
    requestUrl,
  }
}

